import { useAuthStore } from '../store/authStore';
import { hostFromServerUrl, serverKeyFromServerUrl } from '../utils/serverKey';

export function getDeviceForIdentityId(identityId: string) {
  const trimmed = (identityId || '').trim();
  if (!trimmed) return null;
  const state = useAuthStore.getState();
  return Object.values(state.devices).find((device) => device.identityId === trimmed) || null;
}

export function ensureIdentitySelected(identityId: string): boolean {
  const trimmed = (identityId || '').trim();
  if (!trimmed) return false;

  const state = useAuthStore.getState();
  const device = getDeviceForIdentityId(trimmed);
  if (!device) return false;

  if (state.currentDeviceId !== device.deviceId) {
    state.setCurrentDevice(device.deviceId);
  }

  return true;
}

export function ensureServerSelected(serverIdOrUrl: string | undefined | null): boolean {
  const trimmed = (serverIdOrUrl || '').trim();
  if (!trimmed) return false;

  const normalizedRequested = serverKeyFromServerUrl(trimmed) || trimmed;
  const requestedHost = hostFromServerUrl(trimmed) || hostFromServerUrl(normalizedRequested);
  const state = useAuthStore.getState();

  const identity = Object.values(state.identities).find((candidate) => {
    const byServerId = (candidate.serverId || '').trim();
    const byServerUrl = (candidate.serverUrl || '').trim();

    if (byServerId === trimmed || byServerId === normalizedRequested) return true;
    if (serverKeyFromServerUrl(byServerId) === normalizedRequested) return true;
    if (serverKeyFromServerUrl(byServerUrl) === normalizedRequested) return true;

    if (requestedHost) {
      const identityHost = hostFromServerUrl(byServerUrl) || hostFromServerUrl(byServerId);
      if (identityHost && identityHost === requestedHost) return true;
    }

    return false;
  });

  if (!identity) return false;
  return ensureIdentitySelected(identity.identityId);
}

export function getCurrentIdentityId(): string {
  const state = useAuthStore.getState();
  const deviceId = state.currentDeviceId;
  const trustedIdentityId = deviceId ? (state.devices[deviceId]?.identityId || '').trim() : '';
  if (trustedIdentityId) return trustedIdentityId;

  const temporaryMembership = Object.values(state.temporaryMemberships)[0];
  return (temporaryMembership?.identityId || '').trim();
}
